import React, { useCallback, useEffect, useState } from 'react';
import { adminListContacts, adminDeleteContact } from '../../lib/adminApi';
import { Mail, Trash2, MessageSquare } from 'lucide-react';

const AdminContacts = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  const load = useCallback(() => {
    setLoading(true);
    adminListContacts().then((d) => {
      setItems(d);
      setActive((curr) => curr || (d.length ? d[0] : null));
    }).finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleDelete = async (c) => {
    if (!window.confirm('Delete this message?')) return;
    await adminDeleteContact(c.id);
    if (active?.id === c.id) setActive(null);
    load();
  };

  return (
    <div className="p-8">
      <div className="flex items-center gap-3 mb-1">
        <MessageSquare className="text-[#909090]" size={26}/>
        <h1 className="text-3xl font-bold">Contact messages</h1>
      </div>
      <p className="text-zinc-500 text-sm mb-6">{items.length} message{items.length === 1 ? '' : 's'}</p>

      {loading ? (
        <div className="py-20 text-center text-zinc-500">Loading...</div>
      ) : items.length === 0 ? (
        <div className="py-20 text-center text-zinc-500 bg-zinc-950 border border-zinc-900 rounded-lg">No messages yet.</div>
      ) : (
        <div className="grid lg:grid-cols-[380px_1fr] gap-5">
          <div className="bg-zinc-950 border border-zinc-900 rounded-lg divide-y divide-zinc-900 overflow-hidden max-h-[70vh] overflow-y-auto">
            {items.map((c) => (
              <button
                key={c.id}
                onClick={() => setActive(c)}
                className={`w-full text-left p-4 hover:bg-zinc-900/40 transition-colors ${active?.id === c.id ? 'bg-zinc-900/40 border-l-2 border-l-[#909090]' : ''}`}
              >
                <p className="text-white text-sm font-medium truncate">{c.subject}</p>
                <p className="text-xs text-zinc-400 truncate">{c.name} · {c.email}</p>
                <p className="text-xs text-zinc-500 mt-1">{new Date(c.createdAt).toLocaleString()}</p>
              </button>
            ))}
          </div>

          <div className="bg-zinc-950 border border-zinc-900 rounded-lg p-6">
            {active ? (
              <>
                <div className="flex items-start justify-between gap-4 mb-4">
                  <div>
                    <h2 className="text-xl font-bold mb-1">{active.subject}</h2>
                    <p className="text-sm text-zinc-400">From <span className="text-white">{active.name}</span> &lt;{active.email}&gt;</p>
                    <p className="text-xs text-zinc-500 mt-1">{new Date(active.createdAt).toLocaleString()}</p>
                  </div>
                  <div className="flex gap-2">
                    <a href={`mailto:${active.email}?subject=Re: ${encodeURIComponent(active.subject)}`} className="inline-flex items-center gap-1.5 border border-zinc-800 text-zinc-300 hover:border-zinc-600 px-3 py-1.5 rounded text-sm">
                      <Mail size={14}/> Reply
                    </a>
                    <button onClick={() => handleDelete(active)} className="inline-flex items-center gap-1.5 border border-zinc-800 text-zinc-400 hover:text-red-400 hover:border-red-400/50 px-3 py-1.5 rounded text-sm">
                      <Trash2 size={14}/>
                    </button>
                  </div>
                </div>
                <div className="border-t border-zinc-900 pt-4">
                  <p className="text-zinc-300 leading-relaxed whitespace-pre-wrap">{active.message}</p>
                </div>
              </>
            ) : (
              <div className="py-20 text-center text-zinc-500">Select a message to view.</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminContacts;
